import { Icon } from "@circle-react-shared/Icon";
import { useDisableWindowScroll } from "@circle-react-shared/TrixEditor/useDisableWindowScroll";
import { Portal } from "@circle-react-uikit/Portal";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

import { legacyClassNames } from "@/react/helpers/cssAnchorHelpers";

export interface FullScreenLoaderProps {
  message?: string;
}

export const FullScreenLoader = ({ message = "" }: FullScreenLoaderProps) => {
  useDisableWindowScroll(true);

  return (
    <Portal
      className={legacyClassNames("react-loader react-fullscreen-loader")}
    >
      <div
        className={classNames(
          legacyClassNames("overlay"),
          "fixed inset-0 z-[100] flex h-screen w-full items-center justify-center bg-gray-800/75",
        )}
      >
        <div
          className={classNames(
            legacyClassNames("content"),
            "max-w-sm text-center text-white",
          )}
        >
          <Icon type="loader" className="mb-2.5 w-8" />
          <div
            className={classNames(
              legacyClassNames("loader-message"),
              "text-lg",
            )}
          >
            {message}
          </div>
        </div>
      </div>
    </Portal>
  );
};
